const appraiserCounties = {
  getAppraiserCounties: (appraiserId) => `/appraiser-counties/appraisers/${appraiserId}`,
  setAppraiserCounties: (appraiserId) => `/appraiser-counties/appraisers/${appraiserId}`,
  getMultipleAppraiserCounties: () => `/appraiser-counties/appraisers`,
  getAppraiserActiveCoverage: () => `/appraiser-counties/count-by-county`,
};

export default appraiserCounties;
